module.exports = __webpack_public_path__ + "img/hero_character_1.62592834.png";